<template>
    <section class="login">
		<van-popup v-model="isLoginModel" position="top" :style="{ height: '100%' }" class="login_model" :close-on-click-overlay="false">
			<section class="login_box" v-if="type == 'login'">
				<!-- <div class="close_icon" @click="closeModel">
					<van-icon name="cross" />
				</div> -->
				<div class="login_icon">
					<img src="../../assets/img/logo.png">
				</div>
                <div class="brand_slogan">
                    <p>欢迎使用展业牛牛</p>
					<p>十万信贷员都在用的精准获客专家</p>
				</div>
                <div class="form" v-if="loginType == 1">
					<van-field v-model="params1.phone" type="digit" placeholder="请输入手机号" @input="changePhone" maxlength="11" />
					<van-field v-model="params1.verificationCode" type="digit" maxlength="6" placeholder="请输入验证码" @input="changeCode">
						<template #button>
							<p class="code" :class="{code_a: isCode}" @click="getCode" v-if="!isSend">获取验证码</p>
							<p class="code" v-else><van-count-down :time="time" format="ss" @finish="timeFinish" ref="time" />s后重发</p>
						</template>
					</van-field>
				</div>
				<div class="form" v-if="loginType == 2">
					<van-field v-model="params2.account" type="text" maxlength="20" placeholder="手机号/账户号"/>
					<van-field v-model="params2.password" type="password" maxlength="10" placeholder="账户密码"></van-field>
				</div>
				<div class="desc">
					<div @click="agreeFn">
						<img src="../../assets/img/tongyi.png" v-if="!isAgree">
						<img src="../../assets/img/tongyi_a.png" v-else>
					</div>
					<p>已阅读并同意<span @click="lookFn('yinsi')">《应用隐私协议》、</span><span @click="lookFn('yonghu')">《用户服务协议》</span></p>
				</div>
				<div class="bottom_btn">
					<van-button type="primary" @click="loginInSubmit" :style="{background: loginBackground}">立即登录</van-button>
				</div>
                <div class="toggleLoginType" v-if="false">
                    <p v-if="loginType == 1" @click="loginType=2">密码登录</p>
                    <p v-if="loginType == 2" @click="loginType=1">验证码登录</p>
                </div>

                <div class="help">
                    <p @click="openRegistration" class="registration-btn">开户咨询 新客有礼</p>
                </div>
			</section>
			<section v-else-if="type=='yinsi'">
				<div></div>
				<van-nav-bar title="应用隐私协议" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="yinsi" />
			</section>
			<section v-else-if="type=='yonghu'">
				<van-nav-bar title="用户服务协议" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="yonghu" />
			</section>
			<section v-else-if="type=='kehu'">
				<van-nav-bar title="委托推广协议" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="kehu" />
			</section>
		</van-popup>
	</section>
</template>

<script>
import { Notify, Dialog, Toast } from 'vant'
import Agreements from "components/Agreements"
import LoginServer from "api/login"
import settingServer from "api/setting"

export default {
    name: "login",
	props: {
		isLoginModel: Boolean,
		type: String,
		topLeftArrow: Boolean
	},
	components: {
		Agreements
	},
    data() {
		//type: login, yinsi, yonghu, kehu
        return {
			value: '',
			isAgree: 0,
			time: 60000,
            isCode: 0,
			isSend: false,
			time: 60000,

            params1: {
				phone: '',
				verificationCode: '',
			},
			params2: {
				account: '',
				password: '',
			},
			loginBackground: "#D2D8E9",
			flag: true,

            loginType: 2, //默认密码登录
		};
		
    },

    created() {
		// localStorage.removeItem('token')
		this.getDeviceInfo()
	},

    methods: {
		getDeviceInfo() {
			if(window.plus) {
                if(plus.runtime.versionCode>100002) {
					plus.push.getClientInfoAsync((info) => {
						this.params1.cid = info["clientid"];
						this.params2.cid = info["clientid"];
					});
				}

				if(plus.os.name) {
					this.params1.deviceType = plus.os.name
					this.params2.deviceType = plus.os.name
				}

				if(plus.device.vendor) {
					this.params1.market = plus.device.vendor
					this.params2.market = plus.device.vendor
				}
			}
		},

        getCode() {
			if(!this.isCode && !this.isSend) return

            this.isSend = true
            
			let params = {
				captchaNode: "org_login",
				phone: this.params1.phone,
			}

			LoginServer.getSMSCode(params).then((res) => {
				if(res.code ==1) {
					Toast('验证码发送成功')
				}
			})
		},

        checkMobile(str) {
			var re = /^(?:(?:\+|00)86)?1\d{10}$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},

        changePhone() {
			if(this.checkMobile(this.params1.phone)) {
				this.isCode = 1
				if(this.isAgree && this.params1.phone && this.params1.verificationCode) {
					this.loginBackground = "#3A5EEC"
				}
			}else {
				this.isCode = 0
				this.loginBackground="#D2D8E9"
			}
		},

		changeCode() {
			if(this.isAgree && this.params1.phone && this.params1.verificationCode) {
				this.loginBackground = "#3A5EEC"
			}else {
				this.loginBackground="#D2D8E9"
			}
		},

		loginInSubmit() {
            // 短信验证码登录
            if( this.loginType == 1 ) {
                if(!this.params1.phone) return Notify({ type: 'danger', message: '请输入手机号' })
                if(!this.params1.verificationCode) return Notify({ type: 'danger', message: '请输入验证码' })
                if(!this.isAgree) return Notify({ type: 'danger', message: '请阅读并同意协议' })

                if(!this.flag) return
                this.flag = false

                LoginServer.LoginByVerificationCode(this.params1).then((res) => {
                    localStorage.setItem('token', res.data)
                    localStorage.setItem('account', this.params1.phone)
                    this.getAccountInfo()

                    this.flag = true
                }).catch(() => {
                    this.flag = true
                })                

            }

            if( this.loginType == 2 ) {
                if(!this.params2.account) return Notify({ type: 'danger', message: '请输入手机号/账户编号' })
                if(!this.params2.password) return Notify({ type: 'danger', message: '请输入账户密码' })
                if(!this.isAgree) return Notify({ type: 'danger', message: '请阅读并同意协议' })

                if(!this.flag) return
                this.flag = false

                LoginServer.Login(this.params2).then((res) => {
                    localStorage.setItem('token', res.data)
                    localStorage.setItem('account', this.params2.account)
                    this.getAccountInfo()

                    this.flag = true
                }).catch(() => {
                    this.flag = true
                })
            }
		},
        
		agreeFn() {
			if(this.isAgree) {
				this.isAgree = 0
				this.loginBackground="#D2D8E9"
			}else {
				this.isAgree = 1
				this.loginBackground = "#055CE8"
			}
			
		},
		lookFn(type) {
			this.$emit("loginModelFn", type)
		},
		timeFinish() {
			this.isSend = false
		},
		closeModel() {
			this.$emit('closeModel')
		},
		skipKefuFn() {
			this.$router.push({ name: 'kefu' })
		},

        getAccountInfo() {
            settingServer.getAccountInfo().then((res) => {
                localStorage.setItem('accountType', res.data.accountType)
                localStorage.setItem('accountInfoJSONString', JSON.stringify(res.data))

                this.$emit("loginStatus", "ok")
            })
        },

        openRegistration() {
            const registrationUrl = 'https://work.weixin.qq.com/ca/cawcded59657f71c3a';
            
            if(window.plus) {
                // App环境：使用plus API打开外部浏览器
                plus.runtime.openURL(registrationUrl);
            } else {
                // 浏览器环境：使用window.open打开新窗口
                window.open(registrationUrl, '_blank', 'noopener,noreferrer');
            }
        },
	},
};
</script>

<style lang="scss">
.login {
	.login_model {
		.close_icon {
			position: fixed;
			left: 0;
    		z-index: 20;
			height: 59px;
			line-height: 59px;
			color: #7D8290;
			font-size: 22px;
			i {
				padding: 20px 18px;
				padding-bottom: 0;
			}
		}
        .login_icon {
			text-align: left;
			padding-top: 30px;
			padding-left: 29px;
			img {
				width: 72px;
                border-radius: 10px;
			}
		}
		.brand_slogan {
			text-align: left;
			padding-left: 29px;
            padding-top: 10px;
            margin-bottom: 80px;
			p {
				font-size: 18px;
				color: #0c8aee;
				margin: 0;
				font-weight: 500;
				letter-spacing: 1px;
			}
		}
		.form {
			padding-bottom: 20px;
			padding: 0 29px;
			.van-field {
				border-bottom: 1Px solid #f6f6f6;
			}
			.van-field__control {
				font-size: 16px;
				color: #2B2F3A;
			}
			.van-cell {
				padding: 0;
				height: 68px;
				line-height: 68px;
				padding-top: 10px;
				
			}
			.van-cell::after {
				// border-bottom: 1Px solid #f6f6f6
				// top: 0;
				bottom: -10PX;
			}
			.code {
				color: #a2a6ae;
				font-size: 16px;
			}
			.code_a {
				color: #3A5EEC;
			}
		}
		.desc {
			padding: 0 29px;
			padding-left: 50px;
			position: relative;
			margin-top: 18px;
			div	{
				position: absolute;
				top: 0;
				left: 0;
				width: 45px;
				height: 30px;
			}
			img {
				position: absolute;
				top: 2px;
				left: 30px;
				width: 14px;
			}
			p {
				font-size: 13px;
				color: #A2A6AE;
				span {
					color: #2B2F3A;
				}
			}
		}
		.bottom_btn{
			padding: 0 30px;
			padding-top: 26px;
			.van-button--primary {
				width: 100%;
				height: 42px;
				border-radius: 4px;
				border: 0;
				font-size: 15px;
				font-weight: bold;
				color: #FFFFFF;
			}
		}
		.explain {
			color: #A2A6AE;
			font-size: 13px;
			padding-top: 14px;
			text-align: center;
		}
		.van-nav-bar__title {
			color: #2B2F3A;
			font-size: 17px;
		}
		.van-nav-bar__content {
			height: 59px;
		}
		.van-nav-bar__left {
			.van-icon-arrow-left {
				color: #979797;
				font-size: 22px;
			}
		}
		.van-count-down {
			display: inline-block;
			color: #A2A6AE;
			font-size: 16px;
		}
		.fix_top {
			// position: absolute;
			// top: 0;
			// left: 0;
			// width: 100%;
			// z-index: 99;
		}
	}

    .toggleLoginType {
        p {
            text-align: center;
            font-size: 12px;
            line-height: 3;
            color: #3d3d3d;
        }
    }

        .help {
        position: fixed;
        width: 100%;
        bottom: 40px;

        p {
            font-size: 16px;
            color: #d4af37;
            text-align: center;
            text-decoration: underline;
        }

        .registration-btn {
            animation: elegant-glow 3s ease-in-out infinite;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
        }

        .registration-btn:hover {
            transform: translateY(-2px);
            text-shadow: 0 2px 8px rgba(212, 175, 55, 0.4);
        }

        .registration-btn:active {
            transform: translateY(0);
        }
    }

    @keyframes elegant-glow {
        0%, 100% { 
            opacity: 0.8;
            transform: scale(1);
        }
        50% { 
            opacity: 1;
            transform: scale(1.02);
            text-shadow: 0 0 12px rgba(212, 175, 55, 0.6);
        }
    }

	@media screen and (max-height: 650px) {
		.help {
        	position: static;
			margin-top: 24px;
    	}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/components/Login.vue